<template>
  <div>
    <div>
      <SmartTitle heading="1" weight="medium">Regularidade de Envio</SmartTitle>
    </div>
    <div v-if="!loading">
      <v-data-table :headers="headers" :items="listMapped" class="my-4" hide-actions>
        <template v-slot:items="{ item }">
          <td>{{ item.name }}</td>
          <td>{{ item.lastSend }}</td>
          <td>{{ item.vencimento }}</td>
          <td>
            <SmartTag :label="item.status"/>
          </td>
        </template>
      </v-data-table>
    </div>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading :items="11" :height="4"/>
    </SmartCard>
  </div>
</template>


<script>
import api from 'tim-api';
import { formatBRDateTime } from 'utils';

export default {
  data() {
    return {
      loading: true,
      list: [],
      headers: [
        { text: 'Nome do Arquivo', value: 'arquivo', sortable: false },
        { text: 'Último envio', value: 'ultimo_envio', sortable: false },
        { text: 'Vencimento', value: 'vencimento', sortable: false },
        { text: 'Status', value: 'status', sortable: false }
      ]
    };
  },
  computed: {
    listMapped() {
      return (
        (this.list
          && this.list.map(list => ({
            lastSend: formatBRDateTime(list.ultimo_envio),
            status: list.status,
            name: list.name,
            vencimento: formatBRDateTime(list.vencimento)
          })))
        || []
      );
    }
  },
  methods: {
    fetchList() {
      api.get('auditoria/frequenciaenvio').then(({ data }) => {
        this.list = data.data;
        this.loading = false;
      });
    }
  },
  mounted() {
    this.fetchList();
  }
};
</script>

<style>
</style>
